module.exports = __webpack_public_path__ + "static/coming-soon-1dfceda9dc85ffdf13a8a132e67fe52c.png";